<div class="row">
	<div class="col-lg-5">
		<div class="row mb-3">
			<label for="dueDate" class="col-md-4 col-form-label">Due Date</label>
			<div class="col-md-8">
				<ejs-datepicker
					id="dueDate"
					[formControl]="form.controls.dueDate"
					placeholder="mm/dd/yyyy"
					[format]="dateFormat"
					[attr.data-test-id]="testIdPrefix + 'DueDate'">
				</ejs-datepicker>
			</div>
		</div>

		<div class="row mb-3">
			<label class="col-md-4 col-form-label required">Priority</label>
			<div class="col-md-8">
				<pms-constant-dropdown
					[constantList]="taskPriorityOptions"
					[formControl]="form.controls.priority"
					placeholder="Select Priority"
					[attr.data-test-id]="testIdPrefix + 'Priority'">
				</pms-constant-dropdown>
			</div>
		</div>

		<div class="row mb-3">
			<label class="col-md-4 col-form-label required">Category</label>
			<div class="col-md-8">
				<ejs-dropdownlist
					[dataSource]="categories"
					[formControl]="form.controls.categoryId"
					[enabled]="!disableCategorySelect"
					placeholder="Select Category"
					[attr.data-test-id]="testIdPrefix + 'Category'">
				</ejs-dropdownlist>
			</div>
		</div>

		<div class="row mb-3">
			<label class="col-md-4 col-form-label">Patient</label>
			<div class="col-md-8">
				<pms-search-patient
					[formControl]="form.controls.patientId"
					[disabled]="disablePatientSelect"
					[clickToSearch]="true"
					[hideNavigateToPatient]="hideNavigateToPatient"
					[attr.data-test-id]="testIdPrefix + 'Patient'">
				</pms-search-patient>
			</div>
		</div>

		<div class="row mb-3">
			<label for="description" class="col-md-4 col-form-label required">Description</label>
			<div class="col-md-8">
				<textarea
					id="description"
					class="form-control"
					rows="5"
					[formControl]="form.controls.description"
					[attr.data-test-id]="testIdPrefix + 'Description'">
				</textarea>
			</div>
		</div>
	</div>

	<div class="col-lg-4">
		<div class="row">
			<label class="col-auto col-form-label required">Assigned To</label>
			<div class="col">
				<pms-task-assignee-picker
					[initialSelectedPersonIds]="initialSelectedPersonIds"
					[initialRequireAll]="initialRequireAll"
					[initialRoleIds]="initialRoleIds"
					[class.ng-invalid]="form.controls.assigneePersonId.invalid"
					(selectionChanged)="onAssigneeSelectionChanged($event)"
					[attr.data-test-id]="testIdPrefix + 'AssigneePicker'">
				</pms-task-assignee-picker>
			</div>
		</div>
	</div>

	<div class="col-lg-3">
		<div class="d-flex align-items-center gap-2 mb-3">
			<label class="form-check-label" for="notifyOnCompletion">Notify on Completion</label>
			<input
				id="notifyOnCompletion"
				type="checkbox"
				class="form-check-input m-0"
				[formControl]="form.controls.notifyOnCompletion"
				[attr.data-test-id]="testIdPrefix + 'NotifyOnCompletion'"/>
		</div>

		<div class="d-flex align-items-center gap-2">
			<label class="form-check-label" for="notifyOnUpdate">Notify on Update</label>
			<input
				id="notifyOnUpdate"
				type="checkbox"
				class="form-check-input m-0"
				[formControl]="form.controls.notifyOnUpdate"
				[attr.data-test-id]="testIdPrefix + 'NotifyOnUpdate'"/>
		</div>
	</div>
</div>
